<template>

<div class="paging">
    <span class="pageBtn" v-on:click="firstPage"> <i class="fas fa-angle-double-left"></i> </span>
    <span :disabled="currentpage == 1" class="pageBtn" v-on:click="previousPage"> <i class="fas fa-angle-left"></i> </span>
    <!-- <span class="pageBtn" v-for="(page,idx) in totalpages" v-bind:key="idx" v-on:click="movePage(page)"> {{page}} </span> -->
    <span class="pageBtn pageStatus" v-on:click="movePage(page)"> {{currentpage}}/{{totalpages}} </span>
    <span :disabled="currentpage == totalpages" class="pageBtn" v-on:click="nextPage"> <i class="fas fa-angle-right"></i> </span>
    <span class="pageBtn" v-on:click="lastPage"> <i class="fas fa-angle-double-right"></i> </span>
</div>

</template>

<script>

export default {

    props: ['totalpages', 'currentpage'],


    data() {

        return {};
    },


    methods: {
        
        /*******이거 사용안함*******/
        movePage: function(page) {


            console.log("페이지를 찍어주세요", page);
            this.$emit("movePage", page);

        },

        firstPage: function () {

            this.$emit("firstPage");
        },

        lastPage: function () {

            this.$emit("lastPage");
        },

        previousPage: function() {

            console.log("페이지를 이전으로 넘겨주세요");

            this.$emit("previousPage");

        },

        nextPage: function() {

            console.log("페이지를 다음으로 넘겨주세요");

            this.$emit("nextPage");

        },

    }

}

</script>

<style>

.paging {

margin-left: auto;
margin-right: auto;
display: flex;
justify-self: center;

}

.pageBtn {

    display: inline-block;

    cursor: pointer;

    background-color: white;

    font-size: 17px;

    margin: 1px 2px 3px 2px;
    width: 30px;
    height: 30px;
    border-radius: 5px;

    border-style: solid;
    border-color: #e1e1e1;
    border-width: thin; 
    text-align: center;

}

.pageStatus {

    width: 70px;

}

</style>